<mat-card appearance="outlined" class="col-12">
  <mat-card-header> Product Type Summary </mat-card-header>
  <mat-card-content class="row">
    <div class="col-12">
      @if (!solutionId || solutionId === 'ALL') {
        <div class="data-input-warning">
          Note: A solution must be selected at the top of the page to launch to
          Case Explorer
        </div>
      }
    </div>
    <div class="col-12 data-container">
      @if (data && checkOverall()) {
        <table class="content col-12 products">
          <thead class="mb-2">
            <th>Product Type</th>
            <th>Total Amount</th>
            <th>Average Amount</th>
            <th class="text-center">Total</th>
            <th class="large text-center">
              <mat-icon class="positive">check_circle</mat-icon>
            </th>
            <th class="large text-center">
              <mat-icon class="neutral">error</mat-icon>
            </th>
            <th class="large text-center">
              <mat-icon class="negative">remove_circle</mat-icon>
            </th>
          </thead>
          <tbody>
            @for (product of data.productTypeProducts; track product) {
              <tr>
                <td>
                  {{ product.productType }}
                  <button
                    [disabled]="!solutionId || solutionId === 'ALL'"
                    mat-icon-button
                    class="pull-right"
                    (click)="launchCe(product)"
                    color="primary"
                    matTooltip="Launch Case Explorer"
                  >
                    <mat-icon>find_in_page</mat-icon>
                  </button>
                </td>
                <td>{{ mask.applyMoneyMask(product.totalAmount) }}</td>
                <td>{{ mask.applyMoneyMask(product.averageAmount) }}</td>
                <td class="text-center">
                  <span>{{ product.total }}</span>
                  <span>
                    {{ product.total / data.overall.total | percent: '1.2-2' }}
                  </span>
                </td>
                <td class="text-center">
                  <span>{{ product.positive }}</span>
                  <span>
                    {{
                      product.positive > 0
                        ? ((product.positive / product.total) * 100).toFixed(2)
                        : '0.00'
                    }}%
                  </span>
                </td>
                <td class="text-center">
                  <span>{{ product.neutral }}</span>
                  <span>
                    {{
                      product.neutral > 0
                        ? ((product.neutral / product.total) * 100).toFixed(2)
                        : '0.00'
                    }}%
                  </span>
                </td>
                <td class="text-center">
                  <span>{{ product.negative }}</span>
                  <span>
                    {{
                      product.negative > 0
                        ? ((product.negative / product.total) * 100).toFixed(2)
                        : '0.00'
                    }}%
                  </span>
                </td>
              </tr>
            }

            <tr>
              <td>Totals</td>
              <td>{{ mask.applyMoneyMask(data.overall.totalAmount) }}</td>
              <td>{{ mask.applyMoneyMask(data.overall.averageAmount) }}</td>
              <td class="text-center">
                <span>{{ data.overall.total }}</span> <span>100.00%</span>
              </td>
              <td class="text-center">
                <span>{{ data.overall.positive }}</span>
                <span>
                  {{
                    data.overall.positive > 0
                      ? (
                          (data.overall.positive / data.overall.total) *
                          100
                        ).toFixed(2)
                      : '0.00'
                  }}%
                </span>
              </td>
              <td class="text-center">
                <span>{{ data.overall.neutral }}</span>
                <span>
                  {{
                    data.overall.neutral > 0
                      ? (
                          (data.overall.neutral / data.overall.total) *
                          100
                        ).toFixed(2)
                      : '0.00'
                  }}%
                </span>
              </td>
              <td class="text-center">
                <span>{{ data.overall.negative }}</span>
                <span>
                  {{
                    data.overall.negative > 0
                      ? (
                          (data.overall.negative / data.overall.total) *
                          100
                        ).toFixed(2)
                      : '0.00'
                  }}%
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      } @else {
        <div class="no-chart-data"> No data for selected filters </div>
      }
    </div>
  </mat-card-content>
</mat-card>

<mat-card appearance="outlined" class="col-12">
  <mat-card-header> Product Summary </mat-card-header>
  <mat-card-content class="row">
    <div class="col-12">
      @if (!solutionId || solutionId === 'ALL') {
        <div class="data-input-warning">
          Note: A solution must be selected at the top of the page to launch to
          Case Explorer
        </div>
      }
    </div>
    <div class="col-12 data-container">
      @if (data && checkOverall()) {
        <table class="content col-12 products">
          <thead class="mb-2">
            <th>Product</th>
            <th>Total Amount</th>
            <th>Average Amount</th>
            <th class="text-center">Total</th>
            <th class="large text-center">
              <mat-icon class="positive">check_circle</mat-icon>
            </th>
            <th class="large text-center">
              <mat-icon class="neutral">error</mat-icon>
            </th>
            <th class="large text-center">
              <mat-icon class="negative">remove_circle</mat-icon>
            </th>
          </thead>
          <tbody>
            @for (product of data.productNameProducts; track product) {
              <tr>
                <td>
                  {{ product.productName }}
                  <button
                    [disabled]="!solutionId || solutionId === 'ALL'"
                    mat-icon-button
                    class="pull-right"
                    (click)="launchCe(product)"
                    color="primary"
                    matTooltip="Launch Case Explorer"
                  >
                    <mat-icon>find_in_page</mat-icon>
                  </button>
                </td>
                <td>{{ mask.applyMoneyMask(product.totalAmount) }}</td>
                <td>{{ mask.applyMoneyMask(product.averageAmount) }}</td>
                <td class="text-center">
                  <span>{{ product.total }}</span>
                  <span>
                    {{ product.total / data.overall.total | percent: '1.2-2' }}
                  </span>
                </td>
                <td class="text-center">
                  <span>{{ product.positive }}</span>
                  <span>
                    {{
                      product.positive > 0
                        ? ((product.positive / product.total) * 100).toFixed(2)
                        : '0.00'
                    }}%
                  </span>
                </td>
                <td class="text-center">
                  <span>{{ product.neutral }}</span>
                  <span>
                    {{
                      product.neutral > 0
                        ? ((product.neutral / product.total) * 100).toFixed(2)
                        : '0.00'
                    }}%
                  </span>
                </td>
                <td class="text-center">
                  <span>{{ product.negative }}</span>
                  <span>
                    {{
                      product.negative > 0
                        ? ((product.negative / product.total) * 100).toFixed(2)
                        : '0.00'
                    }}%
                  </span>
                </td>
              </tr>
            }
            <tr>
              <td>Totals</td>
              <td>{{ mask.applyMoneyMask(data.overall.totalAmount) }}</td>
              <td>{{ mask.applyMoneyMask(data.overall.averageAmount) }}</td>
              <td class="text-center">
                <span>{{ data.overall.total }}</span> <span>100.00%</span>
              </td>
              <td class="text-center">
                <span>{{ data.overall.positive }}</span>
                <span>
                  {{
                    data.overall.positive > 0
                      ? (
                          (data.overall.positive / data.overall.total) *
                          100
                        ).toFixed(2)
                      : '0.00'
                  }}%
                </span>
              </td>
              <td class="text-center">
                <span>{{ data.overall.neutral }}</span>
                <span>
                  {{
                    data.overall.neutral > 0
                      ? (
                          (data.overall.neutral / data.overall.total) *
                          100
                        ).toFixed(2)
                      : '0.00'
                  }}%
                </span>
              </td>
              <td class="text-center">
                <span>{{ data.overall.negative }}</span>
                <span>
                  {{
                    data.overall.negative > 0
                      ? (
                          (data.overall.negative / data.overall.total) *
                          100
                        ).toFixed(2)
                      : '0.00'
                  }}%
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      } @else {
        <div class="no-chart-data"> No Data for selected filters </div>
      }
    </div>
  </mat-card-content>
</mat-card>
<ngx-loading
  [show]="loading"
  [config]="{ fullScreenBackdrop: false }"
></ngx-loading>
